import { createContext } from "react";

import type useTrialItemIdentityById from "src/hooks/data/load/useTrialItemIdentityById";

/**
 * Describes the trial item identity loader state and its refresh/cache actions.
 */
export interface ITrialItemIdentityContext extends ReturnType<typeof useTrialItemIdentityById> {}

/**
 * Shares trial item identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export default createContext<ITrialItemIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});
